import PropTypes from 'prop-types'
import { Checkbox, FormControl, FormControlLabel, FormHelperText, FormLabel } from "@mui/material"
import { Controller, useFormContext } from "react-hook-form"

const CheckboxMultiple = ({
  control,
  label,
  name,
  options,
  raw = false,
  required = false,
}) => {
  const { getValues, setValue, watch } = useFormContext()
  const toToken = (value) => String(value).replace(/[^a-zA-Z0-9_-]/g, "-")

  const normalizeToArray = (value) => {
    if (Array.isArray(value)) return value
    if (value === undefined || value === null || value === '') return []
    return [value]
  }

  const selectedItems = normalizeToArray(watch(name))

  const handleSelect = (value) => {
    const currentSelectedItems = normalizeToArray(getValues(name))
    const isPresent = currentSelectedItems.includes(value)

    const nextValues = isPresent
      ? currentSelectedItems.filter(item => item !== value)
      : [...currentSelectedItems, value]

    setValue(name, nextValues, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    })
  }

  const requiredRule = required
    ? {
      validate: (value) => normalizeToArray(value).length > 0 || 'Veuillez faire au moins un choix'
    }
    : undefined

  return (
    <Controller
      control={control}
      defaultValue={[]}
      name={name}
      rules={requiredRule}
      render={({ fieldState: { error } }) => (
        <FormControl data-field={name} data-testid={`${name}-group`} error={!!error}>
          <FormLabel data-testid={`${name}-label`} error={!!error}>{label}</FormLabel>
          <div>
            {options.map((option) => (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedItems.includes(option.value)}
                    disabled={Boolean(option.disabled)}
                    inputProps={{
                      'data-field': name,
                      'data-testid': `${name}-checkbox-${toToken(option.value)}`,
                      'data-value': option.value,
                    }}
                    onChange={() => handleSelect(option.value)}
                    size="small"
                  />
                }
                key={option.value}
                label={option.label}
                sx={raw ? { display: 'block' } : {}}
                data-testid={`${name}-option-${toToken(option.value)}`}
              />
            ))}
          </div>
          <FormHelperText>{error ? error.message : ''}</FormHelperText>
        </FormControl>
      )}
    />
  )
}

CheckboxMultiple.propTypes = {
  control: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  raw: PropTypes.bool,
  required: PropTypes.bool,
}

export default CheckboxMultiple
